import debounce from 'lodash.debounce'

/**
 * @param debugMode : bool - verbose debug output
 * @returns {{_resizeObserver: null}|{data(): {_resizeObserver: null}, methods: {sendHeight: (function(): (*))}, beforeDestroy(): undefined, mounted(): undefined}}
 */
export default function pymHeight (debugMode = false) {
  /**
   * vue mixin to trigger iframe size upgrades
   * our fyve application is placed within an iframe inside the fyve.de domain
   * this iframe has a fixes high, so we need to tell the outer site to resize the frame according to the space
   * we need.
   *
   * for this we use pym: http://blog.apps.npr.org/pym.js/
   *
   * pym requires us to call sendHeight() on the pymClient, whenever we have a change in size
   * this mixin contains the logic to detect size changes and call the method.
   *
   * the mixin can be included in every component but only gets active on the most outer
   * component (components without a parent).
   * An ResizeObserver is registered on the DOM element to detect changes in size. This gets unregistered before the
   * component gets destroyed in vue lifecycle.
   *
   * to avoid many calls for multiple resizes in a short time the call to pym client is debounced by 200 ms.
   */
  return {
    data () {
      return {
        _resizeObserver: null
      }
    },
    mounted () {
      if (this.$parent != null) {
        return
      }
      if (debugMode) {
        console.debug('element mounted', this.$el, this)
      }
      const comp = this
      this.$nextTick(() => {
        // eslint-disable-next-line valid-typeof
        if (comp.$el instanceof Element === false) {
          if (debugMode) {
            console.debug('$el not an element', comp.$el)
          }
          return
        }
        comp._resizeObserver = new ResizeObserver(comp.sendHeight)
          .observe(comp.$el)
      })
      this.sendHeight()
    },
    beforeDestroy () {
      if (this.$parent != null) {
        return
      }
      if (debugMode) {
        console.debug('element destroyed', this.$el)
      }
      if (this._resizeObserver) {
        this._resizeObserver.unobserve(this.$el)
      }
    },
    methods: {
      sendHeight: debounce(function () {
        const size = document.body.offsetHeight
        if (debugMode) {
          console.debug('sending height', this._uid, size, window.pymChild)
        }
        window.pymChild.sendHeight()
      }, 200)
    }
  }
}
